module.exports = "https://img.xiyuyouxi.com/saas/img/activity_income.8a7c08eb.png";